module.exports = __webpack_public_path__ + "img/img-099748.jpg";